<template>
    <div class="bottom_pagination pt10">
        <div v-if="paginationData.total > 0">
            <div class="pagination_bar">
                <el-button class="pagebar-button p_n_btn" icon="el-icon-d-arrow-left" :disabled="paginationData.page === 1"
                           :class="[paginationData.page === 1 ? 'normal' : 'active']"
                           @click="changePage('page',paginationData.page=1)"></el-button>
                <el-button class="pagebar-button p_n_btn" icon="el-icon-arrow-left" :disabled="paginationData.page === 1"
                           :class="[paginationData.page === 1 ? 'normal' : 'active']"
                           @click="changePage('page',paginationData.page-1)"></el-button>
                <el-pagination
                        :page-size="paginationData.size"
                        :current-page.sync="paginationData.page"
                        :pager-count="11"
                        layout="pager"
                        :total="paginationData.total"
                        @current-change="changePage('page', paginationData.page)"
                        class="bottom-pagebar"
                >
                </el-pagination>
                <el-button class="pagebar-button p_n_btn" icon="el-icon-arrow-right"
                           :class="[paginationData.page === returnLastPage() ? 'normal' : 'active']"
                           :disabled="paginationData.page === returnLastPage()"
                           @click="changePage('page',paginationData.page+1)"></el-button>
                <el-button class="pagebar-button p_n_btn" icon="el-icon-d-arrow-right"
                           :class="[paginationData.page === returnLastPage() ? 'normal' : 'active']"
                           :disabled="paginationData.page === returnLastPage()"
                           @click="changePage('page',paginationData.page=returnLastPage())"
                ></el-button>
            </div>
            <div class="pagination_bg img_blur"></div>
        </div>
    </div>
</template>
<script>
    import {mapGetters, mapState} from "vuex";
    import EventBus from "@/utils/event-bus";

    export default {
        name: 'PaginationDefaultLayout',
        inject: ['setPage']
        ,
        props: {
            paginationData: {
                type: Object,
                default: {
                    total: 0,
                    page: 0,
                    size: 0,
                }
            },
            listLength: {
                default: 0
            }
        },
        data() {
            return {
                page: 1,
                size: 10,


            }
        },
        computed: {},
        mounted() {

        },
        methods: {
            changePage(key, value) {
                this.setPage(key, value);
            },

            returnLastPage() {
                return Math.ceil(this.paginationData.total / this.paginationData.size);
            },

        },
        watch: {
            'paginationData.page': {
                deep: true,
                handler: function (val, oldVal) {
                    this.page = this.paginationData.page;
                }
            }
        },
    }
</script>